// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_solara_fluted_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_solara_fluted_base: ModuleSchema = {
  "id": "core_solara_fluted_base",
  "uniqueId": "B3D_Q7K2M",
  "createdAt": "2026-10-11T09:56:35+00:00",
  "updatedAt": "2026-10-11T09:56:35+00:00",
  "label": "Solara Fluted Surface",
  "description": "Reusable Solara fluted exterior-surface decoration primitive, independent from any lamp base or support body.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SOLARA_SURFACE",
    "solara",
    "fluted",
    "surface",
    "decoration"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Surface Outer Diameter (Rib Tips)",
      "min": 50,
      "max": 110,
      "step": 1,
      "default": 70,
      "unit": "mm"
    },
    {
      "key": "baseCoreDia",
      "label": "Surface Core Diameter (Trough)",
      "min": 35,
      "max": 80,
      "step": 1,
      "default": 52,
      "unit": "mm"
    },
    {
      "key": "baseHeight",
      "label": "Surface Height",
      "min": 40,
      "max": 160,
      "step": 1,
      "default": 90,
      "unit": "mm"
    },
    {
      "key": "baseRibCount",
      "label": "Surface Flutes Count (Ribs)",
      "min": 20,
      "max": 80,
      "step": 2,
      "default": 44,
      "unit": "ribs"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "solara_fluted_surface",
      "label": "Solara Fluted Surface",
      "default": "#EAB308",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
